<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <div class="header">
        <img src="../../assets/images/activity/activity202212/img1.jpg" alt="">
        <img src="../../assets/images/activity/activity202212/football.png" alt="" class="football">
      </div>
      <img src="../../assets/images/activity/activity202212/title1.png" alt="" class="title">
      <div class="mod">
        <img src="../../assets/images/activity/activity202212/img2.png" alt="">
        <span class="button1" @click="goUrl(338)"></span>
      </div>
      <div class="mod">
        <img src="../../assets/images/activity/activity202212/img3.png" alt="">
        <span class="button2" @click="goUrl(73)"></span>
      </div>
      <img src="../../assets/images/activity/activity202212/title2.png" alt="" class="title">
      <div class="nav-mod">
        <div class="nav-tab">
          <span :class="{cur: navIndex === 0}" @click="navIndex = 0"><img src="../../assets/images/activity/activity202212/football.png" alt="" v-show="navIndex === 0">世界杯概念股</span>
          <span :class="{cur: navIndex === 1}" @click="navIndex = 1"><img src="../../assets/images/activity/activity202212/football.png" alt="" v-show="navIndex === 1">世界杯掘金</span>
        </div>
        <img src="../../assets/images/activity/activity202212/img5.png" alt="" v-show="navIndex === 0">
        <img src="../../assets/images/activity/activity202212/img4.png" alt="" v-show="navIndex === 1">
      </div>
      <p class="note">
        活动须知：《大智慧启航版》、《大智慧专业版》双年卡，季卡，月卡均不参与活动。<br>股市有风险，投资需谨慎
      </p>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      navIndex: 0
    }
  },
    created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {

  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      if (this.token && key !== 4024) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/activity202212/bg.jpg) no-repeat center 100px;
  img{
    display: block;
  }
  .auto{
    width: 1200px;
    margin: 0px auto 0;
  }
  .header{
    position: relative;
  }
  .football{
    width: 70px;
    height: 70px;
    position: absolute;
    left: 436px;
    top: 146px;
    animation: bigger 0.5s 0s linear infinite;
  }
  .title{
    margin: 45px auto 28px;
  }
  .mod{
    position: relative;
    .button1{
      position: absolute;
      width: 134px;
      height: 50px;
      left: 890px;
      top: 211px;
      cursor: pointer;
    }
    .button2{
      position: absolute;
      width: 134px;
      height: 50px;
      left: 900px;
      top: 239px;
      cursor: pointer;
    }
  }
  .nav-mod{
   background: #3766DA;
   padding: 30px 50px 0;
   position: relative;
   height: 750px;
   z-index: 1;
   &:before{
    content: '';
    display: block;
    width: 100%;
    height: 150px;
    background: #C6446B;
    position: absolute;
    left: 0;
    top: 700px;
    z-index: -1;
   }
   .nav-tab{
    display: flex;
    margin: 0 250px 15px;
    justify-content: space-between;
    span{
      font-size: 30px;
      color: rgba($color: #fff, $alpha: 0.8);
      display: flex;
      align-items: center;
      cursor: pointer;
      img{
        width: 28px;
      }
      &.cur{
        color: #fff;
        text-shadow: 0 3px rgba($color: #000000, $alpha: 0.3);
      }
    }
   }
   >img{
    width: 100%;
   }
  }
  .note{
    margin-top: 120px;
    text-align: center;
    padding-bottom: 30px;
    color: rgba($color: #000000, $alpha: 0.65);
    font-size: 20px;
    line-height: 32px;
  }
}
@keyframes bigger {
  0%{
    transform: scale(0.9);
  }
  0%{
    transform: scale(1.1);
  }
  100%{
    transform: scale(0.9);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202212.vue